document.addEventListener("DOMContentLoaded", function () {
  const header = document.querySelector(".header-wrapper");

  if (!header) return;

  function onScroll() {
    if (window.scrollY > 10) {
      header.classList.add("header-wrapper--scrolled");
    } else {
      header.classList.remove("header-wrapper--scrolled");
    }
  }

  onScroll();
  window.addEventListener("scroll", onScroll);
});
